import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  constructor(private authSvc: AuthService) { }

  isLoggedIn = false;
  isAdmin = false;
  username: string;

  ngOnInit(){
    this.isLoggedIn = this.authSvc.isLoggedIn();
    this.isAdmin = this.authSvc.isAdminAccount();
  }

  login() {
    this.authSvc.login();
  }

  logout() {
    this.authSvc.logout();
  }
}
